import { useFormattedPrice } from '@components/PriceLabel/useFormattedPrice';
import { useProductDetailContext } from '@containers/ProductDetailContainer/ProductDetailContext';

export const useConditionVoucherPrice = (price: number) => {
  const { currentCurrency } = useProductDetailContext();

  const formattedPriceObj = useFormattedPrice({
    value: price,
    currency: currentCurrency.code,
  });

  return formattedPriceObj.formattedPriceWithCurrency;
};
